
{
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }
    if(window.eHanlin.platform_env === undefined || window.eHanlin.platform_env === null){
        window.eHanlin.platform_env = {}
        window.eHanlin.platform_env.cdn = 'https://ehanlin-web-public-resource.s3-ap-northeast-1.amazonaws.com'
    }
    !function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a){this.message=a}function e(a){var b=String(a).replace(/=+$/,"");if(b.length%4==1)throw new d("'atob' failed: The string to be decoded is not correctly encoded.");for(var c,e,g=0,h=0,i="";e=b.charAt(h++);~e&&(c=g%4?64*c+e:e,g++%4)?i+=String.fromCharCode(255&c>>(-2*g&6)):0)e=f.indexOf(e);return i}var f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";d.prototype=new Error,d.prototype.name="InvalidCharacterError",b.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||e},{}],2:[function(a,b,c){function d(a){return decodeURIComponent(e(a).replace(/(.)/g,function(a,b){var c=b.charCodeAt(0).toString(16).toUpperCase();return c.length<2&&(c="0"+c),"%"+c}))}var e=a("./atob");b.exports=function(a){var b=a.replace(/-/g,"+").replace(/_/g,"/");switch(b.length%4){case 0:break;case 2:b+="==";break;case 3:b+="=";break;default:throw"Illegal base64url string!"}try{return d(b)}catch(c){return e(b)}}},{"./atob":1}],3:[function(a,b,c){"use strict";function d(a){this.message=a}var e=a("./base64_url_decode");d.prototype=new Error,d.prototype.name="InvalidTokenError",b.exports=function(a,b){if("string"!=typeof a)throw new d("Invalid token specified");b=b||{};var c=b.header===!0?0:1;try{return JSON.parse(e(a.split(".")[c]))}catch(f){throw new d("Invalid token specified: "+f.message)}},b.exports.InvalidTokenError=d},{"./base64_url_decode":2}],4:[function(a,b,c){(function(b){var c=a("./lib/index");"function"==typeof b.window.define&&b.window.define.amd?b.window.define("jwt_decode",function(){return c}):b.window&&(b.window.jwt_decode=c)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./lib/index":3}]},{},[4]);
    const template = `
            <script src="/app/platform-wc/eh-message/dist/js/eh-message-firebase.js"></script>
            <script src="/app/platform-wc/eh-message/dist/dataprovider/eh-message.js"></script>
            <script src="/app/platform-wc/eh-message/dist/js/eh-message.js"></script>
            <style>
                body,ul{margin:0}
                .navbar,body{
                    font-family:'Noto Sans TC',sans-serif;
                    font-weight:400
                }
                .navbar-toggler,a{
                    background-color:transparent
                }
                .dropdown-item,.dropdown-toggle{
                    white-space:nowrap
                }
                .dropdown-item.active,.dropdown-item:active,.dropdown-item:focus,.dropdown-item:hover,.nav-link:hover,a,a:hover{
                    text-decoration:none
                }
                *{
                    -webkit-box-sizing:border-box;
                    box-sizing:border-box
                }
                .d-flex-c{
                    display:-webkit-box;
                    display:-ms-flexbox;
                    display:flex;
                    -webkit-box-pack:center;
                    -ms-flex-pack:center;
                    justify-content:center;
                    -webkit-box-align:center;
                    -ms-flex-align:center;
                    align-items:center
                }
                .navbar,.navbar-nav{
                    display:-webkit-box;
                    display:-ms-flexbox
                }
                @media (max-width:991px){
                    .pt20{
                        padding-top:20px!important
                    }
                }
                .navbar{
                    height:52px;
                    font-family:'Noto Sans TC', 'Microsoft JhengHei', 'PingFang TC', 'Helvetica Neue', Arial, sans-serif;
                    font-weight:400;
                    display:flex;
                    -ms-flex-wrap:wrap;
                    flex-wrap:wrap;
                    -webkit-box-align:center;
                    -ms-flex-align:center;
                    align-items:center;
                    -webkit-box-pack:justify;
                    -ms-flex-pack:justify;
                    justify-content:space-between;
                    padding:0 16px;
                    z-index:99900;
                    -webkit-box-shadow:0 0 3px rgba(0,0,0,.15);
                    box-shadow:0 0 3px rgba(0,0,0,.15);
                    -moz-user-select:none;
                    -webkit-user-select:none;
                    -ms-user-select:none;
                    user-select:none;
                }
                @media (max-width:991px){
                    .navbar{
                        height: 48px;
                        padding:0 12px
                    }
                }
                .navbar-nav,.navbar-nav-mobile{
                    margin-bottom:0;
                    padding-left:0;
                    list-style:none
                }
                .navbar-item-mobile{
                    display:none
                }
                @media (max-width:991px){
                    .navbar-item-mobile{
                        display:-webkit-box;
                        display:-ms-flexbox;
                        display:flex;
                        -webkit-box-pack:center;
                        -ms-flex-pack:center;
                        justify-content:center;
                        -webkit-box-align:center;
                        -ms-flex-align:center;align-items:center
                    }
                }
                .navbar-nav{
                    display:flex;
                    -webkit-box-orient:horizontal;
                    -webkit-box-direction:normal;
                    -ms-flex-direction:row;
                    flex-direction:row
                }
                @media (max-width:991px){
                    .navbar-nav{
                        -webkit-box-orient:vertical;
                        -webkit-box-direction:normal;
                        -ms-flex-direction:column;
                        flex-direction:column
                    }
                }
                .navbar-nav-mobile{
                    display:-webkit-box;
                    display:-ms-flexbox;
                    display:flex
                }
                .navbar-toggler{
                    padding:9px;
                    font-size:1.25rem;
                    line-height:1;
                    border:1px solid transparent;
                    border-radius:.25rem;
                    cursor:pointer
                }
                .navbar-toggler:focus,.navbar-toggler:hover{
                    text-decoration:none;
                    outline:0
                }
                .navbar-toggler-icon{
                    display:inline-block;
                    width:1.5em;
                    height:1.5em;
                    vertical-align:middle;
                    content:"";
                    background:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(13, 108, 190, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") center center no-repeat;background-size:100% 100%
                }
                .navbar-text{
                    display:inline-block;
                    padding-top:.5rem;
                    padding-bottom:.5rem
                }
                .navbar-collapse{
                    -ms-flex-preferred-size:auto;
                    flex-basis:auto
                }
                @media (max-width:991px){
                    .navbar-collapse{
                        -webkit-box-shadow:0 3px 3px rgba(0,0,0,.05);
                        box-shadow:0 3px 3px rgba(0,0,0,.05);
                        display:none;
                        position:absolute;
                        text-align:center;
                        width:100%;
                        max-height:calc(100vh - 48px);
                        top:48px;
                        left:0;background-color:#fff;
                        overflow:auto;
                        -webkit-transition:all .3 ease;transition:all .3 ease
                    }
                }
                .navbar-collapse.show{
                    display:block!important;
                    -webkit-animation:fadeIn .3s linear;
                    animation:fadeIn .3s linear
                }
                .logo{width:235px}
                .logo-mobile{
                    width:138px;
                    display:none
                }
                @media (max-width:500px){
                    .logo{display:none}
                    .logo-mobile{display:block}
                }
                .navbar{
                    background-color:#fff;
                    position:fixed;
                    top:0;
                    width:100%
                }
                .dropdown,.nav-item,.nav-item2,.nav-item3{
                    position:relative
                }
                .navbar-mobile{display:none}
                .nav-item{padding:14px 16px}
                @media (max-width:991px){
                    .navbar-mobile{
                        display:-webkit-box;
                        display:-ms-flexbox;
                        display:flex
                    }
                    .nav-item{padding:0}
                }
                .nav-item2{padding:14px 8px}
                @media (max-width:991px){
                    .nav-item2{padding:0}
                }
                .nav-item3{padding:0 8px 0 16px}
                @media (max-width:991px){
                    .nav-item3{padding:0}
                }
                .nav-item-chart{
                    padding:14px 16px
                }
                @media (max-width:991px){
                    .nav-item-chart{
                        padding:0;display:none
                    }
                }
                .nav-item-mobile{padding:0 7px}
                .nav-item-mobile:nth-child(4){padding:0 5px 0 2px}
                .nav-link{
                    color:#0D6CBE;
                    font-size:16px;
                    cursor:pointer
                }
                .nav-link:hover{color:#4B9DE4}
                .nav-link:hover:before{
                    border-color:#4B9DE4 transparent transparent
                }
                @media (max-width:991px){
                    .nav-link{display:block;padding:14px 0}
                }
                .dropdown-menu.show{
                    display:block!important;
                    -webkit-animation:fadeIn .1s linear;
                    animation:fadeIn .1s linear;
                    -webkit-transform-origin:0 0;
                    transform-origin:0 0}
                @-webkit-keyframes fadeIn{from{opacity:0}to{opacity:1}}
                @keyframes fadeIn{from{opacity:0}to{opacity:1}}
                .dropdown-toggle::after{
                    display:inline-block;
                    margin-left:.255em;
                    vertical-align:.255em;
                    content:"";
                    border-top:.3em solid;
                    border-right:.3em solid transparent;
                    border-bottom:0;
                    border-left:.3em solid transparent
                }
                .dropdown-menu{
                    -webkit-filter:drop-shadow(0 0 3px rgba(0, 0, 0, .1));
                    filter:drop-shadow(0 0 3px rgba(0, 0, 0, .1));
                    position:absolute;
                    top:100%;
                    left:50%;
                    z-index:1000;
                    -webkit-transform:translateX(-50%);
                    transform:translateX(-50%);
                    display:none;
                    float:left;
                    min-width:10rem;
                    padding:4px 0;
                    font-size:1rem;color:#212529;text-align:left;list-style:none;background-clip:padding-box
                }
                @media (max-width:991px){
                    .dropdown-menu{-webkit-filter:none;filter:none;padding:0;position:static;float:none;-webkit-transform:translateX(0);transform:translateX(0)
                    }
                }
                .dropdown-submenu,.icon-chart{position:relative}
                .navbar-nav li:hover>ul.dropdown-menu{display:block}
                .dropdown-container{margin-top:14px;background-color:#fff}
                .dropdown-submenu .dropdown-menu{top:0;right:100%;-webkit-transform:translateX(-150%);transform:translateX(-150%);margin-top:0}
                @media (max-width:991px){
                    .navbar-nav li:hover>ul.dropdown-menu{display:none}
                    .dropdown-container{margin:0}
                    .dropdown-container .dropdown-item{background-color:#0D6CBE;color:#fff}
                    .dropdown-container .dropdown-item:hover{background-color:#4B9DE4;color:#fff}
                    .dropdown-submenu .dropdown-menu{-webkit-transform:translateX(0);transform:translateX(0);right:0}
                }
                .sub-dropdown{background-color:#0D6CBE;padding:0}
                .sub-dropdown .dropdown-item{color:#fff;cursor:pointer}
                .sub-dropdown .dropdown-item:hover{background-color:#4B9DE4;color:#fff}
                @media (max-width:991px){
                    .sub-dropdown .dropdown-item{background-color:#005CA0}.sub-dropdown .dropdown-item:hover{background-color:#02528E}
                }
                .dropdown-item{display:block;width:100%;clear:both;border:0;color:#0D6CBE;font-size:16px;padding:12px;text-align:center;cursor:pointer}
                .dropdown-item:hover{background-color:#fff;color:#4B9DE4}
                .icon-chart .chart-sum,.icon-mail .mail-sum{left:65%;background-color:#FD9841;color:#fff;font-weight:500;border-radius:30px;font-size:12px;line-height:12px;padding:3px 5px 2px}
                .icon-chart .chart{width:24px;height:20px;background-image:url(${window.eHanlin.platform_env.cdn}/web/eh-navbar/icon-chart.svg)}
                .icon-line,.icon-et{width:20px;height:20px}
                .icon-chart .chart:hover{-webkit-filter:brightness(1.3);filter:brightness(1.3)}
                .icon-chart .chart-sum{position:absolute;top:-30%}
                .icon-et{background-image:url(${window.eHanlin.platform_env.cdn}/web/eh-navbar/icon-et.svg)}
                .icon-et:hover{-webkit-filter:brightness(1.3);filter:brightness(1.3)}
                .icon-line{background-image:url(${window.eHanlin.platform_env.cdn}/web/eh-navbar/icon-line.svg)}
                .icon-line:hover{-webkit-filter:brightness(1.3);filter:brightness(1.3)}
                .icon-mail{position:relative}
                .icon-mail .mail{width:22px;height:16px;background-image:url(${window.eHanlin.platform_env.cdn}/web/eh-navbar/icon-mail.svg)}
                .icon-mail .mail:hover{-webkit-filter:brightness(1.3);filter:brightness(1.3)}
                .icon-mail .mail-sum{position:absolute;top:-50%}.icon-arrow:before{position:absolute;content:url(${window.eHanlin.platform_env.cdn}/web/eh-navbar/arrow.svg);display:block;top:50%;margin-top:3px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}
                @media (max-width:991px){.icon-arrow:before{display:none}}
                .icon-arrow:hover:before{content:url(${window.eHanlin.platform_env.cdn}/web/eh-navbar/arrow-hover.svg)}
                .icon-down:before,.icon-point:before{position:absolute;content:'';width:0;height:0;border-style:solid}.icon-down:before{display:block;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);right:4px;border-width:6px 4px 0;border-color:#0D6CBE transparent transparent}
                @media (max-width:991px){.icon-down:before{display:none}}
                .icon-point:before{display:block;top:4px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-width:0 8px 14px;border-color:transparent transparent #fff}
                .dropdown-person{left:-40%}
                .dropdown-person .dropdown-item{color:#0D6CBE}
                .dropdown-person .dropdown-item:hover{color:#4B9DE4}
                @media (max-width:991px){
                    .icon-point:before{display:none}
                    .navbar-nav li:hover>ul.dropdown-menu.point2,ul.dropdown-menu.point2{display:block}
                    .nav-item-head{display:none}
                    .dropdown-person{left:0}
                    .dropdown-person .dropdown-item{color:#0D6CBE;background-color:transparent;padding:14px 0}
                    .dropdown-person .dropdown-item:hover{color:#4B9DE4;background-color:transparent}
                }
                .dropdown-person .logout-btn .dropdown-item{color:#fff;background-color:#FD9841;border-radius:5px}
                .dropdown-person .logout-btn .dropdown-item:hover{background-color:#F28121;color:#fff}.dropdown-person .dropdown-container{padding:12px}
                .dropdown-person hr{border:.5px solid #DDD;margin:8px 0 0}
                @media (max-width:991px){
                    .dropdown-person .dropdown-container{padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}
                    .dropdown-person hr{display:none}
                }
                .dropdown-person ::slotted(img),.dropdown-person img{width:16px;height:16px}
                .dropdown-person li{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#747474;cursor:default}
                .dropdown-person li:nth-child(1){padding:8px 0}@media (max-width:991px){.dropdown-person li{color:#0D6CBE}
                .dropdown-person li:nth-child(1){padding:0}}.dropdown-person li:nth-child(2){padding:0 0 8px;letter-spacing:1px;font-size:14px}
                @media (max-width:991px){
                    .dropdown-person li:nth-child(2){padding:0}
                    .container-user{-webkit-box-ordinal-group:3;-ms-flex-order:2;order:2}
                    .container-user>li:nth-child(1){padding:28px 0 14px;color:#747474}
                    .container-user>li:nth-child(2){padding:0 0 18px;color:#747474}
                    .container-profile{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;border-top:1px solid #DDD}
                    .container-logout{-webkit-box-ordinal-group:4;-ms-flex-order:3;order:3;padding:0 0 14px}
                    .nav-item-mail{display:none}
                }
                .nav-item-mail{padding:14px 8px}
                .user-asset{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:2px 0}
                @media (max-width:991px){.user-asset{display:none}}
                .assets,::slotted(.assets){font-size:12px;padding-left:8px}
                .logout-btn .dropdown-item,.logout-btn ::slotted(.dropdown-item){color:#fff;background-color:#FD9841;border-radius:5px}
                .logout-btn .dropdown-item:hover,.logout-btn ::slotted(.dropdown-item):hover{background-color:#F28121;color:#fff}
                .point2:before{left:84%;right:0}
                .head{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}
                .head ::slotted(img),.head img{border-radius:50%;width:32px;height:32px;margin-top:auto;margin-bottom:auto}
            </style>
            <eh-message></eh-message>
            <nav class="navbar"><a class="navbar-brand d-flex-c" href="/app/index.html"><img class="logo" src="/images/ehanlin_logo.svg"><img class="logo-mobile" src="https://public.ehanlin.com.tw/web/eh-navbar/ehanlin-logo-mobile.svg"></a>
                <div class="navbar-item-mobile">
                    <div class="navbar-mobile" id="mobileNav">
                        <ul class="navbar-nav-mobile">
                            <li class="d-flex-c nav-item-mobile"><a class="nav-link" id="cartIcon" href="#">
                                <div class="icon-chart">
                                <div class="chart"></div>
                                <div class="chart-sum">
                                    <div class="car_sum">0</div>
                                </div>
                                </div></a></li>
                            <li class="d-flex-c nav-item-mobile logged-in" id="mail"><a class="nav-link mailIcon">
                                <div class="icon-mail">
                                <div class="mail"></div>
                                <div class="mail-sum">
                                    <div id="mail_sum">0</div>
                                </div>
                                </div></a></li>
                            <li class="d-flex-c nav-item-mobile"><a class="nav-link nav-link-coach">
                                <div class="icon-et"></div></a></li>
                            <li class="d-flex-c nav-item-mobile"><a class="nav-link" href="http://line.me/R/ti/p/MtsRQz_Hn5">
                                <div class="icon-line"></div></a></li>
                        </ul>
                    </div>
                    <div class="navbar-toggler" id="hamBtn" data-toggle-class="show" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></div>
                </div>
                <div class="collapse d-flex-c navbar-collapse" id="navbarNavDropdown">
                    <ul class="navbar-nav">
                    <li class="nav-item"><a class="nav-link" href="/app/online-trial/trial-list.html">免費試用</a></li>
                    <li class="nav-item"><a class="nav-link" href="/app/online-showcase/product-list.html#JS&all&all&all">課程總覽</a></li>
                    <li class="nav-item"><a class="nav-link" href="/app/online-activation/key-step-1.html">課程開通</a></li>
                    <li class="nav-item dropdown" data-toggle-class="show" data-target="#navbarDropdown-1">
                        <div class="nav-link icon-down" id="navbar">升學專區</div>
                        <ul class="navbarDropdown dropdown-menu icon-point" id="navbarDropdown-1">
                        <div class="dropdown-container">
                            <li class="dropdown-submenu" data-toggle-class="show" data-target="#subDropdown-1">
                            <div class="dropdown-item icon-arrow">國中會考</div>
                            <ul class="subDropdown dropdown-menu sub-dropdown" id="subDropdown-1">
                                <li><a class="dropdown-item" href="/event/cap/">110會考命中分析</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/secret/index.html">超額比序揭密</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/resolving/index.html#CAP">會考解題專區</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/download/index.html#CAP">歷屆考題下載</a></li>
                                
                            </ul>
                            </li>
                            <li class="dropdown-submenu" data-toggle-class="show" data-target="#subDropdown-2">
                            <div class="dropdown-item icon-arrow">高中學測</div>
                            <ul class="subDropdown dropdown-menu sub-dropdown" id="subDropdown-2">
                                <li><a class="dropdown-item" href="/event/highscrev/index.html">學測趨勢解密</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/resolving/index.html#GSAT">學測解題專區</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/download/index.html#GSAT">歷屆考題下載</a></li>
                            </ul>
                            </li>
                            <li class="dropdown-submenu" data-toggle-class="show" data-target="#subDropdown-3">
                            <div class="dropdown-item icon-arrow">高中指考</div>
                            <ul class="subDropdown dropdown-menu sub-dropdown" id="subDropdown-3">
                                <li><a class="dropdown-item" href="/event/pre-exam/resolving/index.html#AST">指考解題專區</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/download/index.html#AST">歷屆考題下載</a></li>
                            </ul>
                            </li>
                            <li class="dropdown-submenu" data-toggle-class="show" data-target="#subDropdown-4">
                            <div class="dropdown-item icon-arrow">高中分科測驗</div>
                            <ul class="subDropdown dropdown-menu sub-dropdown" id="subDropdown-3">
                                <li><a class="dropdown-item" href="/event/pre-exam/resolving/index.html#ASTN">分科測驗解題專區</a></li>
                                <li><a class="dropdown-item" href="/event/pre-exam/download/index.html#ASTN">歷屆試題下載</a></li>
                            </ul>
                            </li>
                            <li class="dropdown-submenu">
                                <a class="dropdown-item" href="/event/online-refbook/refbook.html">參考書專區</a>
                            </li>
                        </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown" data-toggle-class="show" data-target="#navbarDropdown-2">
                        <div class="nav-link icon-down" id="navbar">活動專區</div>
                        <ul class="navbarDropdown dropdown-menu icon-point" id="navbarDropdown-2">
                            <div class="dropdown-container">
                                <li><a class="dropdown-item" href="/event/award/index.html">風雲盃獎學金申請</a></li>
                                <li><a class="dropdown-item" href="/app/points-activity/">翰林童話鎮保衛戰</a></li>
                                <li><a class="dropdown-item" href="/event/schoolstar/">校園大使</a></li>
                                <li><a class="dropdown-item e-coach-drop-item">加入e家教</a></li>
                            </div>
                        </ul>
                    </li>

                    <li class="d-flex-c nav-item-chart"><a class="nav-link" href="/app/shop/cart.html">
                        <div class="icon-chart">
                            <div class="chart"></div>
                            <div class="chart-sum">
                            <div class="car_sum">0</div>
                            </div>
                        </div></a></li>
                    <li class="nav-item pt20 login" id="register">
                        <a class="nav-link" href="/app/member-center/register.html">註冊</a>
                    </li>
                    <li class="nav-item2 login" id="loginBotton">
                        <a class="nav-link" href="/app/member-center/login.html">登入</a>
                    </li>
                    
                    <li class="d-flex-c nav-item-mail logged-in" id="mail">
                        <a class="nav-link mailIcon">
                        <div class="icon-mail">
                            <div class="mail"></div>
                            <div class="mail-sum">
                                <div id="mail_sum">0</div>
                            </div>
                        </div>
                        </a>
                    </li>
                    
                    
                    <li class="d-flex-c nav-item3 dropdown logged-in" id="member">
                        <div class="nav-link nav-item-head" id="dropdownPerson" aria-haspopup="true" aria-expanded="false">
                            <div class="head">
                                <slot name="myPicture">
                                    <img id="myPicture" src="${window.eHanlin.platform_env.cdn}/web/avatar/ps00.png" alt="">
                                </slot>
                            </div>
                        </div>
                        <ul class="dropdown-menu dropdown-menu2 dropdown-person icon-point point2" aria-labelledby="dropdownPerson">
                        <div class="dropdown-container">
                            <div class="container-user">
                            <li>
                                <slot name="user">
                                    <div id="user"></div>
                                </slot>
                            </li>
                            <li>
                                <slot name="studentId">
                                    <div id="studentId"></div>
                                </slot>
                            </li>
                            <li>
                                <div class="row-asset">
                                    <div class="user-asset">
                                        <img src="https://public.ehanlin.com.tw/web/eh-navbar/ecoin.png" alt="e幣">
                                        <slot name="ecoin">
                                            <div class="assets" id="ecoin">0</div>
                                        </slot>
                                    </div>
                                    <div class="user-asset">
                                        <img src="https://public.ehanlin.com.tw/web/eh-navbar/dimon.png" alt="寶石">
                                        <slot name="dimon">
                                            <div class="assets" id="dimon">0</div>
                                        </slot>
                                        
                                    </div>
                                </div>
                            </li>
                            </div>
                            <hr>
                            <div class="container-profile">
                                <li>
                                    <a class="dropdown-item" href="/my-course/my/owned/Courses.html">我的課程</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" href="/app/points-activity/currency-bank.html">雲端銀行</a>
                                </li>
                                <li>
                                    <slot name="userInfo">
                                        <a class="dropdown-item" href="/app/member-center/user-setting.html" id="userInfo">會員資料</a>
                                    </slot>
                                </li>
                            </div>
                            <div class="container-logout">
                                <li class="logout-btn" id="logoutBotton">
                                    <a class="dropdown-item">登出</a>
                                </li>
                            </div>
                        </div>
                        </ul>
                    </li>
                    </ul>
                </div>
            </nav>
    `;
    customElements.define('eh-navbar', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'});
            const removeNavbar  = shadowRoot.querySelectorAll('.navbarDropdown');
            shadowRoot.innerHTML = template;

            loadScriptFromInnerHTML();

            ///---- ShadowDOM (Web Component) ----///
            const toggleClass  = shadowRoot.querySelectorAll('[data-toggle-class]');
            if (toggleClass) {
                for (let i = 0 ; i < toggleClass.length ; i += 1) {
                    let elem = toggleClass[i];
                    elem.addEventListener('click', (event) => {
                        if(window.innerWidth <= 991){
                            let className = elem.getAttribute('data-toggle-class');
                            let targetClick = elem.getAttribute('data-target').slice(1);
                            let targetClass = targetClick.split('-')[0];
                            let targetElementsByClass = shadowRoot.querySelectorAll(`.`+targetClass);
                            if(shadowRoot.querySelector(`#`+targetClick).classList.contains(className) === true){
                                shadowRoot.querySelector(`#`+targetClick).classList.toggle(className);
                                event.stopPropagation();
                            }
                            else if(shadowRoot.querySelector(`#`+targetClick).classList.contains(className) === false){
                                for(let i = 0 ; i < targetElementsByClass.length ; i++ ){
                                    targetElementsByClass[i].classList.remove(className);
                                }
                                shadowRoot.querySelector(`#`+targetClick).classList.toggle(className);
                                event.stopPropagation();
                            }
                        }
                    });
                }
            }
            shadowRoot.querySelector('#hamBtn').addEventListener("click",function(){
                const removeNavbar  = shadowRoot.querySelectorAll('.navbarDropdown');
                const removeSub  = shadowRoot.querySelectorAll('.subDropdown');
                for (let i = 0 ; i < removeNavbar.length ; i++ ) {
                    removeNavbar[i].classList.remove('show');
                }
                for (let i = 0 ; i < removeSub.length ; i++ ) {
                    removeSub[i].classList.remove('show');
                }
            });

            shadowRoot.querySelector('#cartIcon').addEventListener("click", function () {
                if (window.ga) {
                    window.ga('send', 'event', 'InitiateCheckout', 'checkout', 'cartIcon');
                }
                if (window.fb) {
                    window.fb('InitiateCheckout', null);
                }
                window.location = "/app/shop/cart.html"
            });

            shadowRoot.querySelectorAll('.mailIcon').forEach(icon => {
                icon.addEventListener("click", function () {
                    if (shadowRoot.querySelector('eh-message')){
                        shadowRoot.querySelector('eh-message').setAttribute('open', 'true');
                    }
                    else{
                        window.location = "/ms_message/messageList.html"
                    }
                })
            })

            shadowRoot.querySelector('.e-coach-drop-item').addEventListener("click", function () {
                toECoach();
            });

            shadowRoot.querySelector('.nav-link-coach').addEventListener("click", function () {
                toECoach();
            });

            shadowRoot.querySelector('#logoutBotton').addEventListener("click", function () {
                let user = getLoginUserInfo()
                if(user){
                    logout();
                }
            });

            function loadScript(script){
                return new Promise((reslove, rejected) => {
                    const newScript = document.createElement('script');
                    const src = script.getAttribute('src');
                    if (src) {
                        newScript.setAttribute('src', src);
                        document.head.appendChild(newScript);

                        newScript.onload = () => reslove();
                        newScript.onerror = err => rejected();
                    }
                });
            }

            function loadScriptFromInnerHTML(){
                const scripts = shadowRoot.querySelectorAll('script');
                return Array.prototype.slice.apply(scripts).reduce((chain, script) =>
                    {
                        return chain.then(() => loadScript(script));
                    }, Promise.resolve()
                );
            }

            function logout() {
                fetch("/user-bg/member-center/logout",{
                    method: "PUT",
                    headers: { "content-type": "application/json"},
                }).then(res => {
                    if(res.ok) {
                        changeDisplay(".login", "");
                        changeDisplay(".logged-in", "none");
                        window.location.href = res.headers.get("Location");
                    }else{
                        changeDisplay(".login", "none");
                        changeDisplay(".logged-in", "");
                    }
                 }).catch(err => {
                    console.error(err)
                    changeDisplay(".login", "none");
                    changeDisplay(".logged-in", "");
                })
            }

            function toECoach(){
                let cookieToken = getEhToken();
                if(cookieToken!=null){
                    let user = cookieToken.user;
                    if(!!user){
                        fetch(`/coach-web/eTutorStudent/isStudent?id=${user.userId}`)
                            .then(response => {
                                if (response.ok) {
                                    return response.text();
                                }
                            })
                            .then(result => {
                                if (result=="true") {
                                    window.location.href = "/app/coach/";
                                }else{
                                    window.location.href = "/event/ecoach/intro-jr.html"
                                }
                            })
                    }else{
                        window.location.href = "/event/ecoach/intro-jr.html";
                    }
                }
            }

            function removeNavBarToggle(){
                const removeHam  = shadowRoot.querySelector('#navbarNavDropdown');
                removeHam.classList.remove('show');
                const removeSub  = shadowRoot.querySelectorAll('.subDropdown');
                for (let i = 0 ; i < removeNavbar.length ; i++ ) {
                    removeNavbar[i].classList.remove('show');
                }
                for (let i = 0 ; i < removeSub.length ; i++ ) {
                    removeSub[i].classList.remove('show');
                }
            }

            function checkLoginToken(){
                let info = getLoginUserInfo();
                if(info){
                    renewTokenOrInvalidate();
                    const user  = shadowRoot.querySelector('#user');
                    user.innerText = info.name;
                    const studentId  = shadowRoot.querySelector('#studentId');
                    if(info.emailVerified){
                        studentId.innerText = info.studentCard;
                        studentId.style.display = "";
                    }else{
                        studentId.style.display = "None";
                    }
                    const pic  = shadowRoot.querySelector('#myPicture');

                    pic.src = `${window.eHanlin.platform_env.cdn}${info.defPic}`;
                    pic.addEventListener("error", function (){
                        //--- 錯誤大頭照 ---//
                        pic.src=`${window.eHanlin.platform_env.cdn}/web/avatar/ps404.png`;
                    });
                    showUserAsset();
                    return !!user;
                }
                return false;
            }

            function renewTokenOrInvalidate(){
                fetch("/user-bg/token/renew-or-invalidate")
                .then(res => {if(res.ok) return res.text()})
                .then(result => {
                    if(result === "invalidate"){
                        logout()
                        getSessionToken()
                    }
                })
                .catch(err => {
                    console.error(err);
                })
            }

            function getLoginUserInfo(){
                const payload = getEhToken();
                if(payload) return payload.user;
                return null;
            }

            function getSessionInfo(){
                const payload = getEhToken();
                if(payload && payload.ehSystem) return payload.ehSystem.sessionId;
                return null;
            }

            function changeDisplay(className, display) {
                let elems = shadowRoot.querySelectorAll(className);
                let index = 0, length = elems.length;
                for ( ; index < length; index++) {
                    elems[index].style.display = display;
                }
            }

            function showCartsNumber() {
                fetch(`/shop/order/current?ts=${new Date().getTime()}`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        "content-type": "application/json;charset=utf-8"
                    }
                }).then((response) => {
                    if (response.ok){
                        return response.json();
                    }
                    return null;
                }).then((result) => {
                    if(result){
                        if(result.cart && result.cart.items){
                            let count = result.cart.items.length;
                            if(count){
                                const sum  = shadowRoot.querySelectorAll('.car_sum');
                                sum.forEach(it => it.innerText = count)
                            }
                        }
                    }
                });
            }

            function showMessageNonReadCount() {
                fetch(`/ms_message/nonReadCount?ts=${new Date().getTime()}`,{
                    method: "GET",
                    headers: {"content-type":"application/json"},
                }).then(res => {
                    if(res.ok) return res.json();
                }).then(result => {
                    const count = result.result;
                    if(result.success && count !== 0){
                        changeDisplay(".mail-sum", "");
                        const sum  = shadowRoot.querySelector('#mail_sum');
                        sum.innerText = count;
                    }else{
                        changeDisplay(".mail-sum", "None");
                    }
                }).catch(err => console.error("綱路發生錯誤，請稍候再試。"))
            }

            function showUserAsset() {
                fetch(`/student-asset/totalAssets`,{
                    method: "GET",
                    headers: {"content-type":"application/json"},
                }).then(res => {
                    if(res.ok) return res.json();
                }).then(result => {
                    const asset = result.content;
                    const coins  = shadowRoot.querySelector('#ecoin');
                    coins.innerText = asset.coins;
                    const dimon  = shadowRoot.querySelector('#dimon');
                    dimon.innerText = asset.gems;
                })
            }

            const getSessionToken = async () => {
                fetch("/user-bg/token/session-token").then((res)=>{
                    if(res.ok){
                        showCartsNumber();
                    }
                })
            }

            const pagesToRedirect = [
                "/app/member-center/certify-email.html",
                "/app/member-center/questionnaire.html",
                "/app/member-center/new-comer.html",
                "/app/shop/cart.html",
                "/app/online-showcase/handout-list.html"
            ]

            if(checkLoginToken()){
                changeDisplay(".login", "None");
                changeDisplay(".logged-in", "");
                showCartsNumber();
            }else{
                if(window.location.protocol.toLowerCase() !== 'file:'){
                    if(pagesToRedirect.includes(window.location.pathname) || (window.eHanlin && window.eHanlin.needLogined)){
                        let redirect = `${window.location.pathname}${window.location.search}${window.location.hash}`
                        window.location.href = `/app/member-center/login.html?redirect=${encodeURIComponent(redirect)}`;
                    }
                }
                changeDisplay(".login", "");
                changeDisplay(".logged-in", "None");
                if(!getSessionInfo()){
                    getSessionToken();
                }else{
                    showCartsNumber();
                }
            }
            
            window.onresize = function(){
                if(window.innerWidth > 991){
                    removeNavBarToggle();
                }
            };

            function refreshNavInfo(){
                let info = getLoginUserInfo();
                if(info){
                    renewTokenOrInvalidate();
                    const user  = shadowRoot.querySelector('#user');
                    user.innerText = info.name;
                    const pic  = shadowRoot.querySelector('#myPicture');
                    pic.src = `${window.eHanlin.platform_env.cdn}${info.defPic}`;
                    pic.addEventListener("error", function (){
                        //--- 錯誤大頭照 ---//
                        pic.src=`${window.eHanlin.platform_env.cdn}/web/avatar/ps404.png`;
                    });
                    showUserAsset();
                }
            }

            const handlePostMessage = () => {
                let messenger = window.eHanlin.platform_message;
                messenger.registerMessage(messenger.ACTION.ADD_TO_CART,
                    async function (data){
                                await fetch("/shop/order/add-commodity",{
                                    method: "PUT",
                                    headers: { "Content-type":"application/json;charset=utf-8"},
                                    body: JSON.stringify({ salePlanId: data.id })
                                })
                                .then(res => {
                                    if(res.ok) return res.json();
                                })
                                .then(result => {
                                    if (window.ga) {
                                        window.ga('send', 'event', 'AddToCart', 'toCart', 'AddOne');
                                    }
                                    if (window.fb) {
                                        let items = result.cart.items;
                                        let product = items.filter(function(item, index, array){
                                            return item.id === data.id;
                                        });
                                        window.fb('AddToCart', {items: product});
                                    }
                                    changeDisplay(".chart-sum", "");
                                    shadowRoot.querySelectorAll(".car_sum").forEach(it => {
                                        it.innerText = result.cart.items.length;
                                    })
                                    let msg = {
                                        action: messenger.ACTION.REFRESH_CART_VIEW,
                                        data: result
                                     }
                                    messenger.sendMessage(msg);
                                })
                                .catch(err => console.error(err))
                })
                messenger.registerMessage(messenger.ACTION.REMOVE_FROM_CART,
                    async function (data){
                                await fetch("/shop/order/remove-commodity",{
                                    method: "DELETE",
                                    headers: { "Content-type":"application/json;charset=utf-8"},
                                    body: JSON.stringify({ salePlanId: data.id })
                                })
                                    .then(res => {
                                        if(res.ok) return res.json();
                                    })
                                    .then(result => {
                                        changeDisplay(".chart-sum", "");
                                        shadowRoot.querySelectorAll(".car_sum").forEach(it => {
                                            it.innerText = result.cart.items.length;
                                        })
                                        let msg = {
                                            action: messenger.ACTION.REFRESH_CART_VIEW,
                                            data: result
                                        }
                                        messenger.sendMessage(msg);
                                    })
                                    .catch(err => console.error(err))
                })

                messenger.registerMessage(messenger.ACTION.ADD_GROUP_TO_CART,
                    async function (data){
                        await fetch("/shop/order/add-commodities",{
                            method: "PUT",
                            headers: { "Content-type":"application/json;charset=utf-8"},
                            body: JSON.stringify({ salePlanIds: data.ids })
                        })
                            .then(res => {
                                if(res.ok) return res.json();
                            })
                            .then(result => {
                                if (window.ga) {
                                    window.ga('send', 'event', 'AddToCart', 'toCart', 'AddGroup');
                                }
                                if (window.fb) {
                                    let items = result.cart.items;
                                    let products = items.filter(function(item, index, array){
                                        return data.ids.indexOf(item.id) !== -1;
                                    });
                                    window.fb('AddToCart', {items: products});
                                }
                                changeDisplay(".chart-sum", "");
                                shadowRoot.querySelectorAll(".car_sum").forEach(it => {
                                    it.innerText = result.cart.items.length;
                                })
                                let msg = {
                                    action: messenger.ACTION.REFRESH_CART_VIEW,
                                    data: result
                                }
                                messenger.sendMessage(msg);
                            })
                            .catch(err => console.error(err))
                    })

                messenger.registerMessage(messenger.ACTION.REMOVE_ALL_FROM_CART,
                    async function (data){
                        await fetch("/shop/order/remove-allcommodity",{
                            method: "DELETE",
                            headers: { "Content-type":"application/json;charset=utf-8"}
                        })
                            .then(res => {
                                if(res.ok) return res.json();
                            })
                            .then(result => {
                                changeDisplay(".chart-sum", "");
                                shadowRoot.querySelectorAll(".car_sum").forEach(it => {
                                    it.innerText = result.cart.items.length;
                                })
                                let msg = {
                                    action: messenger.ACTION.REFRESH_CART_VIEW,
                                    data: result
                                }
                                messenger.sendMessage(msg);
                            })
                            .catch(err => console.error(err))
                    })
                messenger.registerMessage(messenger.ACTION.REFRESH_USER_INFO,
                    function (data){
                        refreshNavInfo();
                    })
            }
            if(window.eHanlin.platform_message){
                handlePostMessage();
            }
        }
    });

    function getEhToken(){
        const cookie = getCookieByName("eh-token");

        if(cookie){
            try {
                return jwt_decode(cookie)
            }
            catch (e){
                console.error(e);
                return null;
            }
        }
        return null;
    }

    function getCookieByName(name){
        return document.cookie.split(";").find(cookie => {
            return cookie.split('=')[0].trim() === name
        });
    }


}
